// #region imports

// --- Angular
import { Component,  Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-field-hint',
  templateUrl: './field-hint.component.html',
  styleUrls: ['./field-hint.component.scss']
})
export class FieldHintComponent {
  @Input() labelFor: string = '';
  @Input() hideIcon: boolean = false;
}
